<template>
    <el-dialog
        class="recharge"
        :visible.sync="priceVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Paid in amount"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="rechargeForm"
                :model="rechargeForm"
                label-width="110px"
                :rules="rules"
                :inline-message="true"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Total amount" size="small">
                            <span class="recharge-num">$ {{ actAmount }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="17">
                        <el-form-item label="Amount" size="small" prop="num">
                            <el-input
                                clearable
                                placeholder=""
                                maxlength="200"
                                size="small"
                                v-model="rechargeForm.num"
                            >
                                <i slot="prefix">$</i>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="">
                    <el-col :span="17">
                        <el-form-item label="Remark" size="small">
                            <el-input
                                clearable
                                placeholder=""
                                maxlength="200"
                                size="small"
                                v-model="rechargeForm.remark"
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 6 }"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Submit</el-button
            >
            <el-button size="small" @click="priceVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import util from "@/utils/util.js";
import { mapActions } from "vuex";
export default {
    data() {
        return {
            actAmount: "0.00",
            rechargeForm: {
                num: "",
                remark: "",
                amount: "",
            },
            rules: {
                num: [
                    {
                        validator: util.validateAmount,
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    methods: {
        amountChange(val) {
            this.rechargeForm.num = val;
        },
        save() {
            this.$refs["rechargeForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .orderChangeActAmount(
                            {
                                order_id: this.tableItem.id,
                                price: this.rechargeForm.num,
                                remark: this.rechargeForm.remark,
                            },
                            "post"
                        )
                        .then((res) => {
                            this.loading = false;
                            this.closeDialog();
                            this.$parent[this.funcName]();
                            this.$message.success(
                                this.$i18n.locale == "zh" ? "成功" : "Success"
                            );
                        });
                }
            });
        },
        getEntityInfo() {
            cmofferApi.entityInfo({}, "get").then((res) => {
                if (res) {
                    this.actAmount = res.data.balance;
                }
            });
        },
        closeDialog() {
            this.rechargeForm = {
                num: "",
                remark: "",
                amount: "",
            };
            this.$refs["rechargeForm"].clearValidate();
            this.$refs["rechargeForm"].resetFields();
            this.$emit("update:priceVisible", false);
        },
        async initialize() {
            // this.getEntityInfo();
        },
    },
    props: {
        priceVisible: Boolean,
        tableItem: Object,
        funcName: String,
    },
    watch: {
        priceVisible() {
            if (this.priceVisible) {
                console.log("this.tableItem: ", this.tableItem);
                this.actAmount = this.tableItem.act_amount;
                this.initialize();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.recharge {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }

        .el-select {
            width: 100%;
        }

        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
    }
    .recharge-num {
        font-size: 18px;
        font-weight: 600;
    }
    .rm-method {
        margin-top: 20px;
        ::v-deep .el-radio-group {
            width: 100%;
            .el-radio {
                display: flex;
                align-items: center;
                padding: 4px 10px;
                box-sizing: border-box;
                border: 1px solid #e1e2e3;
                font-size: 16px;
                min-height: 40px;
                background-color: #ffffff;
                margin-right: 0;
                .el-radio__label {
                    span {
                        margin-left: 5px;
                    }
                }
                & + .el-radio {
                    margin-top: 10px;
                }
                &.is-checked {
                    border-color: $color-primary-blue;
                }
            }
        }
    }
}
</style>
